var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crud-modal',{attrs:{"title":"User hinzufügen","action":"create","on-submit":_vm.submit,"on-close":() => _vm.$emit('close'),"validation-scope":"user","error-message":_vm.errorMessage}},[_c('user-form',{attrs:{"company-id":_vm.companyId,"sso-providers":_vm.ssoProviders,"user":_vm.user}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }